import React, { createContext, useState } from 'react'
import PatientVUService from '../../services/PatientVU/PatientVU.service'
import PropTypes from 'prop-types'

export const PatientVUContext = createContext()

export const PatientVUContextProvider = (props) => {
  const [patients, setPatients] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchPatients = async (portalName) => {
    console.log('fetchPatients', portalName)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.fetchPatients(portalName)
      setPatients(response.data)
    } catch (err) {
      console.error('Error fetching patients:', err)
      setError(err.message || 'Failed to fetch patients')
    } finally {
      setLoading(false)
    }
  }

  const addPatient = async (identifier, displayName, portalName) => {
    console.log('addPatient', identifier, displayName, portalName)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.addPatient(
        identifier,
        displayName,
        portalName
      )
      // Refresh the patients list
      await fetchPatients(portalName)
      return response
    } catch (err) {
      console.error('Error adding patient:', err)
      setError(err.message || 'Failed to add patient')
      throw err
    } finally {
      setLoading(false)
    }
  }

  const updatePatient = async (
    patientId,
    identifier,
    displayName,
    portalName
  ) => {
    console.log('updatePatient', patientId, identifier, displayName, portalName)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.updatePatient(
        patientId,
        identifier,
        displayName,
        portalName
      )
      // Refresh the patients list
      await fetchPatients(portalName)
      return response
    } catch (err) {
      console.error('Error updating patient:', err)
      setError(err.message || 'Failed to update patient')
      throw err
    } finally {
      setLoading(false)
    }
  }

  const deletePatient = async (patientId, portalName) => {
    console.log('deletePatient', patientId, portalName)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.deletePatient(patientId)
      // Refresh the patients list
      await fetchPatients(portalName)
      return response
    } catch (err) {
      console.error('Error deleting patient:', err)
      setError(err.message || 'Failed to delete patient')
      throw err
    } finally {
      setLoading(false)
    }
  }

  const linkPatientToSession = async (patientId, sessionId) => {
    console.log('linkPatientToSession', patientId, sessionId)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.linkPatientToSession(
        patientId,
        sessionId
      )
      return response
    } catch (err) {
      console.error('Error linking patient to session:', err)
      setError(err.message || 'Failed to link patient to session')
      throw err
    } finally {
      setLoading(false)
    }
  }

  const getPatientById = async (patientId) => {
    console.log('getPatientById', patientId)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.getPatientById(patientId)
      return response
    } catch (err) {
      console.error('Error fetching patient by ID:', err)
      setError(err.message || 'Failed to fetch patient details')
      throw err
    } finally {
      setLoading(false)
    }
  }

  const getPatientSessions = async (patientId) => {
    console.log('getPatientSessions', patientId)
    setLoading(true)
    setError(null)
    try {
      const response = await PatientVUService.getPatientSessions(patientId)
      return response.data
    } catch (err) {
      console.error('Error fetching patient sessions:', err)
      setError(err.message || 'Failed to fetch patient sessions')
      throw err
    } finally {
      setLoading(false)
    }
  }

  return (
    <PatientVUContext.Provider
      value={{
        patients,
        loading,
        error,
        fetchPatients,
        addPatient,
        updatePatient,
        deletePatient,
        linkPatientToSession,
        getPatientById,
        getPatientSessions
      }}
    >
      {props.children}
    </PatientVUContext.Provider>
  )
}

PatientVUContextProvider.propTypes = {
  children: PropTypes.node.isRequired
}
